import bee from "./Bee";
export default{
    name: "Sliders",
    get_sliders(query, success, fail) {
        var q = {
            sliders: {
                _ob: ["position"]
            }
        };
        if(query.page){
            q.sliders["_w"] = [
                ["page","e",query.page]
            ];
        }
        bee.get(q).then(res => {
            if (success) {
                success(res.sliders);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    get_slider(query, success, fail) {
        bee.get({
            slider:{
                _w:[
                    ["id","e",query.id]
                ]
            }
        }).then(res => {
            if (success) {
                success(res.slider);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    post_slider(query, success, fail) {
        bee.post({
            slider: { 
               ... query
            }
        }).then(res => {
            if (success) {
                success(res.slider);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    update_slider(query, success, fail) {
        var q = {
            slider: { 
               ...query,
               _w:[
                   ["id","e",query.id]
               ]
            }
        };
        delete q.slider.id;
        bee.update(q).then(res => {
            if (success) {
                success(res.slider);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
}